import { createElement, useState, useEffect } from 'react';
import { Grid } from '@alifd/next';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { fIsMobile } from '../../../utils';
const { Row, Col } = Grid;
const GridLayout = function GridLayout(props) {
    const { columnRatio, rowGap, colGap, children, splot, ...otherProps } = props;
    const cols = columnRatio?.split(':') || [];
    const [error, setError] = useState(false);
    const [isMoble, setIsMoble] = useState(fIsMobile());
    const listenResize = () => {
        setIsMoble(fIsMobile());
    };
    useEffect(() => {
        window.addEventListener('resize', listenResize);
        return () => {
            window.removeEventListener('resize', listenResize);
        };
    }, []);
    const colNodes = cols.map((item, index) => {
        let span = Number(item) * 2;
        return (createElement(Col, { span: isMoble ? 24 : span },
            createElement("div", { style: { marginBottom: colGap + 'px' } }, children[index] ? (children[index]) : (createElement("div", { className: "lc-container-placeholder" }, '拖拽组件或模板到这里')))));
    });
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref })) : (createElement("div", { className: "grid-layout base_bg" },
        createElement(Row, { className: "row", gutter: rowGap, wrap: true }, colNodes)))));
};
GridLayout.displayName = 'GridLayout';
export default GridLayout;
